import * as React from "react";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import { useNavigate } from "react-router-dom";
import { initialImage, Service } from "../../Interface/Service";
import { Message } from "../../Interface/Message";
import {
  Box,
  Button,
  Checkbox,
  Container,
  CssBaseline,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AppHelper from "../../Helper/AppHelper";
import Loader from "../Loader";
import AlertBox from "../CommonComponent/AlertBox";
import { AppSettings } from "../../AppSettings";
import degalutImgSrc from "../../images/dsv_logo1.png";

export default function AddServices() {
  const [serviceInfo, setServiceInfo] = React.useState<Service>({
    id: 0,
    name: "",
    description: "",
    serviceSSOLink: "",
    iconName: "",
    imageSrc: "",
    priority: "",
    imageFile: null,
    isActive: true,
    isAdminActive: true,
  });

  const [serviceImage, setServiceImage] = React.useState<initialImage>({
    imageSrc: degalutImgSrc,
    imageFile: null,
  });
  const [isChecked, setIsChecked] = React.useState(true);
  const [isAdminChecked, setIsAdminChecked] = React.useState(true);



  const handleChange = (event: {
    target: { files?: any; name?: any; value?: any };
  }) => {
    const { name, value } = event.target;
    if (name === "url") {
      if (event.target.files.length > 0) {
        let imageFile = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (x) => {
          setServiceImage({
            ...value,
            imageFile,
            imageSrc: x.target?.result,
          });
        };
        reader.readAsDataURL(imageFile);
      } else {
        setServiceImage({
          ...value,
          imageFile: null,
          imageSrc: degalutImgSrc,
        });
      }
    }
  };

  const [pageName, setPageName] = React.useState("Add Service");
  const [openLoader, setOpenloader] = React.useState(false);

  const [formValidation, setformValidation] = React.useState({
    name: false,
    description: false,
    serviceSSOLink: false,
    priority: false,
  });

  const [alertBoxmsg, setAlertBoxmsg] = React.useState<Message>({
    Type: "",
    Text: "",
  });

  const handleInputChange = (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | (Event & { target: { value: string; id: string } })
  ) => {
    const { id, value } = e.target;
    setServiceInfo({ ...serviceInfo, [id]: value });
    isValidForm(id, value);
  };

  const handleCheckboxChange = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) };
  }) => {
    setIsChecked(event.target.checked);
  };
//isAdminChecked
const handleAdminCheckboxChange = (event: {
  target: { checked: boolean | ((prevState: boolean) => boolean) };
}) => {
  setIsAdminChecked(event.target.checked);
};
  function isValidForm(itemID: string, value: string) {
    console.log(
      serviceInfo.name,
      serviceInfo.description,
      serviceInfo.serviceSSOLink
    );

    let validate = {
      name: AppHelper.isNullorEmpty(serviceInfo.name),
      description: AppHelper.isNullorEmpty(serviceInfo.description),
      serviceSSOLink: AppHelper.isNullorEmpty(serviceInfo.serviceSSOLink),
      priority: false,
    };
    if (serviceInfo.priority !== "") {
      if (!AppHelper.isNumber(serviceInfo.priority)) validate.priority = true;
    }

    if (!AppHelper.validateLink(serviceInfo.serviceSSOLink || "")) {
      validate.serviceSSOLink = true;
    }

    setformValidation(validate);

    if (
      validate.name ||
      validate.description ||
      validate.serviceSSOLink ||
      validate.priority
    ) {
      return false;
    }
    return true;
  }

  const handleSubmit = () => {
    let msg: Message = { Text: "", Type: "" };

    if (isValidForm("", "")) {
      setOpenloader(true);

      let apiUrl = AppSettings.API_URL + "Service/AddService";

      if (pageName !== "Add Service") {
        apiUrl = AppSettings.API_URL + "Service/UpdateService";
      }

      const formData = new FormData();
      formData.append("id", serviceInfo.id?.toString() || "0");
      formData.append("name", serviceInfo.name?.toString() || "");
      formData.append("description", serviceInfo.description || "");
      formData.append("serviceSSOLink", serviceInfo.serviceSSOLink || "");
      formData.append("priority", serviceInfo.priority || "");
      formData.append("imageFile", serviceImage.imageFile || "");
      formData.append("iconLocation", "");
      formData.append("isActive", isChecked?.toString() || "true");
      formData.append("isAdminActive", isAdminChecked?.toString() || "true");
      formData.append("createdBy", AppHelper.getUser().id.toString() || "");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + AppHelper.getUser().token,
        },
        body: formData,
      };

      fetch(apiUrl, requestOptions)
        .then((response) => {
          console.log(response);
          if (!response.ok) {
            if (response.status == 401) navigate("/SessionExpired");
            else
              throw new Error(
                `API Error, This is an HTTP error: The status is ${response.status}`
              );
          }
          return response.json();
        })
        .then((data) => {
          if (data) {
            if (data.successes.length > 0) {
              if (pageName !== "Add Service") {
                navigate("/ServicesList?msg=Update_Successful");
              } else {
                navigate("/ServicesList?msg=Create_Successful");
              }
            } else {
              msg = { Text: data.errors[0], Type: "Error" };
              setAlertBoxmsg(msg);
            }
          }

          setOpenloader(false);
        })
        .catch((err) => {
          if (err.message === "Failed to fetch") {
            navigate("/SessionExpired");
          } else {
            //API Error.
            msg = { Text: err.message, Type: "Error" };
            setAlertBoxmsg(msg);
          }
        })
        .finally(() => {
          setOpenloader(false);
        });

      return false;
    }
  };

  function clearForm() {
    setServiceInfo({
      id: 0,
      name: "",
      description: "",
      serviceSSOLink: "",
      iconName: "",
      imageFile: null,
      priority: "",
      imageSrc: "",
      isActive: true,
      isAdminActive: true,
    });
    setServiceImage({
      imageSrc: degalutImgSrc,
      imageFile: null,
    });
  }
  const navigate = useNavigate();

  const effectCount = React.useRef(true);
  React.useEffect(() => {
    AppHelper.isSuperAdminUser();
    if (effectCount.current) {
      effectCount.current = false;
    }

    let msg: Message = { Text: "", Type: "" };
    let apiUrl = "";

    let query = AppHelper.getQueryValue().get("id");

    if (query === null) {
      setPageName("Add Service");
      return;
    }
    if (query !== undefined || query !== "" || query !== null) {
      setPageName("Update Service");
      setOpenloader(true);
      apiUrl = AppSettings.API_URL + "Service/GetServicesByID?id=" + query;
      fetch(apiUrl, AppHelper.requestOptions("POST"))
        .then((response) => {
          console.log(response);
          if (!response.ok) {
            if (response.status == 401) navigate("/SessionExpired");
            else
              throw new Error(
                `API Error, This is an HTTP error: The status is ${response.status}`
              );
          }
          return response.json();
        })
        .then((data) => {
          if (data !== undefined) {
            setServiceInfo(data);
            let service: Service = data || " ";
            if (AppHelper.isNullorEmpty(service.iconName) === false) {
              setServiceImage({
                imageFile: null,
                imageSrc: service.imageSrc,
              });
            }
            setIsChecked(service.isActive);
            setIsAdminChecked(service.isAdminActive);
          }
        })
        .catch((err) => {
          if (err.message === "Failed to fetch") {
            navigate("/SessionExpired");
          } else {
            msg = { Text: err.message, Type: "Error" };
            setAlertBoxmsg(msg);
          }
        })
        .finally(() => {
          setOpenloader(false);
        });
    }
  }, []);

  return (
    <>
      <div className="page-container">
        <div className="add-details">
          <Loader value={openLoader}></Loader>
            <Container component="main" maxWidth="md">
              <CssBaseline />
              <Box
                sx={{
                  marginTop: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography
                  component="h1"
                  variant="h5"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <ManageAccountsIcon
                    sx={{ fontSize: 30, marginRight: 1 }}
                  ></ManageAccountsIcon>{" "}
                  <b>{pageName}</b>
                </Typography>

                {alertBoxmsg.Text !== "" && (
                  <AlertBox value={alertBoxmsg}></AlertBox>
                )}

                <Box component="form" noValidate sx={{ mt: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      {" "}
                      <TextField
                        id="name"
                        label="Service Name"
                        multiline
                        fullWidth
                        maxRows={4}
                        value={serviceInfo.name}
                        onChange={(e) => handleInputChange(e)}
                        error={formValidation.name}
                        helperText={
                          formValidation.name ? "Error : Field is required" : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        id="priority"
                        label="Display Priority"
                        placeholder="Display Priority"
                        multiline
                        fullWidth
                        error={formValidation.priority}
                        value={serviceInfo.priority}
                        onChange={(e) => handleInputChange(e)}
                        helperText={
                          formValidation.priority
                            ? "Error : Must be an Integer"
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="serviceSSOLink"
                        label="SSO link"
                        placeholder="Placeholder"
                        multiline
                        fullWidth
                        value={serviceInfo.serviceSSOLink}
                        onChange={(e) => handleInputChange(e)}
                        error={formValidation.serviceSSOLink}
                        helperText={
                          formValidation.serviceSSOLink
                            ? serviceInfo.serviceSSOLink == ""
                              ? "Error : Field is required"
                              : "Error : Invalid link."
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      {" "}
                      <TextField
                        id="description"
                        label="Description"
                        fullWidth
                        multiline
                        rows={2}
                        value={serviceInfo.description}
                        onChange={(e) => handleInputChange(e)}
                        error={formValidation.description}
                        helperText={
                          formValidation.description
                            ? "Error : Field is required"
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      {" "}
                      <div>
                        <img
                          alt=""
                          src={serviceImage.imageSrc}
                          className="service-icon-list"
                        />
                      </div>
                      <TextField
                        fullWidth
                        type="file"
                        name="url"
                        onChange={handleChange}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <Stack spacing={2} padding={2} direction="row">
                    <FormControlLabel
                      className="chekcBox"
                      control={
                        <Checkbox
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                          name="isActive"
                          id="isActive"
                        />
                      }
                      label="Enabled"
                    /> 
                    
                    {AppHelper.getUser().userType === "Super Admin" && (
                     <FormControlLabel
                      className="chekcBox"
                      control={
                        <Checkbox
                          checked={isAdminChecked}
                          onChange={handleAdminCheckboxChange}
                          name="isAdminActive"
                          id="isAdminActive"
                        />
                    }
                      label="Admin Enabled"
                    />
                    )}
                    <Button
                      variant="contained"
                      size="large"
                      startIcon={<LabelImportantIcon />}
                      onClick={() => handleSubmit()}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => navigate("/ServicesList")}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Box>
              </Box>
            </Container>
        </div>{" "}
        <div className="blank-div"></div>
      </div>
    </>
  );
}
